// Pop-up menus (a message's or a chat's chevron) open downward, unless that
// runs past the bottom of the scrolling area they're in: then they open
// upward if there's more room there, and scroll if neither side fits.
import { useLayoutEffect, useState } from "preact/hooks";

/** `gap`: how far above its anchor's bottom edge the menu ends when opened
 * upward (the CSS `bottom` of its ".up" rule). */
export function useFlip(ref: { current: HTMLElement | null }, container: string, gap: number): { up: boolean; maxHeight?: number } {
  const [place, setPlace] = useState<{ up: boolean; maxHeight?: number }>({ up: false });
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const area = el.closest(container)?.getBoundingClientRect() ?? { top: 0, bottom: window.innerHeight };
    const anchor = (el.offsetParent as HTMLElement | null)?.getBoundingClientRect();
    const r = el.getBoundingClientRect();
    if (r.bottom <= area.bottom - 4 || !anchor) return; // fits below
    const below = area.bottom - r.top - 8;
    const above = anchor.bottom - gap - area.top - 8;
    const up = above > below;
    const room = up ? above : below;
    setPlace({ up, maxHeight: r.height > room ? Math.max(120, room) : undefined });
  }, []);
  return place;
}
